import * as React from 'react';
import { AbstractSharingLink } from './AbstractSharingLink';

export class Xing extends AbstractSharingLink {
    public render() {
        const titleAttribute = this.context.i18n.translate('Auf XING teilen');
        const model = this.props.model;
        const localUrl = encodeURIComponent(this.buildSharingUri(model));
        const uri = `https://www.xing.com/spi/shares/new?`
            + `url=${localUrl}`;

        return <div className="jc-share-link -xing">
            <a href={uri} target="_blank" rel="noopener noreferrer" title={titleAttribute}>
                <i className="fab fa-xing"/>
            </a>
        </div>;
    }
}
